import React from 'react'
import './HealthITHero.scss'

export class HealthITHero extends React.Component {
  render() {
    return (
      <div
        className="health-it-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Health IT</h1>
            <h2>Secure, Compliant AI Solutions for Healthcare and Medical Device Review</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default HealthITHero
